import { Grid, Typography } from "@material-ui/core";

import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocTableSimple from "../../../utils/MeditocTableSimple";
import { getEliminarFoliosColumns } from "../../../../models/EmpresaModel";
import { useEmpresa } from "../../../../context/EmpresaContext";

export default function EliminarFolios() {
    const {
        empresaSeleccionada,
        foliosSeleccionados,
        modalOpenEliminarFolios,
        handleOpenEliminarFolios,
        handleSubmitEliminarFolios,
    } = useEmpresa();

    return (
        <MeditocModal
            size="small"
            align="center"
            title="Eliminar folios"
            open={modalOpenEliminarFolios}
            setopen={handleOpenEliminarFolios}
            okfunc={handleSubmitEliminarFolios}
        >
            <Grid container spacing={1} className="center">
                <Grid item xs={12}>
                    <Typography paragraph align="center">
                        ¿Desea eliminar los folios seleccionados?
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Folio de empresa:" value={empresaSeleccionada.sFolioEmpresa} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre de empresa:" value={empresaSeleccionada.sNombre} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Folios seleccionados:" value="" />
                </Grid>
                <Grid item xs={12}>
                    <MeditocTableSimple data={foliosSeleccionados} columns={getEliminarFoliosColumns()} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
